import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {useEffect, useMemo} from 'react'
import {connect} from 'react-redux'
import {readEndpoint} from 'redux-json-api'

import {Box} from '@mui/material'

import {humanizedFullName} from '../../lib/nameTools'
import {findRawResourceByAttributeId} from '../../lib/plan_data/userData'

import './funeralHomeDetails.scss'

export const FuneralHomeDetails = ({
  everplanId,
  firm,
  funeralDirectorContactInfo,
  vaultExtensionData = Map(),
  ...otherProps
}) => {
  useEffect(() => {
    otherProps.readEndpoint(`advisor-contact-cards/${everplanId}`)
  }, [])

  const hasAddressInfo = useMemo(() => (
    firm.get('billing-address1') ||
    firm.get('billing-address2') ||
    firm.get('billing-city') ||
    firm.get('billing-state') ||
    firm.get('billing-zip')
  ), [firm])

  const firmLogo = useMemo(() => (
    funeralDirectorContactInfo.get('avatar-url') ||
    firm.get('logo')
  ), [firm, funeralDirectorContactInfo])

  return (
    <div className='funeral-home-details'>
      <div className='section-title'>Funeral home details</div>
      <Box className='box'>
        <div className='details-logo-container'>
          {
            (firmLogo) &&
            <img
              alt=''
              className='logo'
              src={firmLogo}
            />
          }
          <div className='details-container'>
            <div className='name'>{firm.get('name')}</div>
            <div className='container'>
              {
                hasAddressInfo &&
                <div className='details left-details'>
                  <div className='detail label'>Address:</div>
                  <div className='detail'>{firm.get('billing-address1')}</div>
                  <div className='detail'>{firm.get('billing-address2')}</div>
                  <div>
                    {
                      `${firm.get('billing-city')}, 
                      ${firm.get('billing-state')},
                      ${firm.get('billing-zip')}`
                    }
                  </div>
                </div>
              }
              {
                vaultExtensionData.get('afp') &&
                <div className='details right-details'>
                  <div className='detail'>
                    <span className='label'>Funeral Planner:</span>
                    {' '}{humanizedFullName(vaultExtensionData.get('afp'))}
                  </div>
                  <div className='detail'>
                    <span className='label'>Email:</span>
                    {' '}{vaultExtensionData.getIn(['afp', 'email'])}
                  </div>
                  <div className='detail'>
                    <span className='label'>Phone:</span>
                    {' '}{vaultExtensionData.getIn(['afp', 'phone'])}
                  </div>
                </div>
              }
            </div>
            {
              firm.get('website') &&
              <div className='funeral-home-info'>
                <div className='website'>
                  <span className='label'>Website:</span>
                  {' '}{firm.get('website')}
                </div>
              </div>
            }
          </div>
        </div>
      </Box>
    </div>
  )
}

FuneralHomeDetails.propTypes = {
  everplanId: PropTypes.string,
  firm: PropTypes.instanceOf(Map),
  funeralDirectorContactInfo: PropTypes.instanceOf(Map),
  vaultExtensionData: PropTypes.instanceOf(Map)
}

const mapStateToProps = ({api}, {everplanId}) => {
  const funeralDirectorContactInfo = findRawResourceByAttributeId({
    rawResource: api['advisor-contact-cards'],
    attribute: 'everplan-id',
    id: everplanId
  })

  return {funeralDirectorContactInfo}
}

export default connect(mapStateToProps, {readEndpoint})(FuneralHomeDetails)
